import { render } from "./Providers.vue?vue&type=template&id=f2bf9490&scoped=true"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"

import "./Providers.vue?vue&type=style&index=0&id=f2bf9490&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2bf9490"]])

export default __exports__